import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "@/lib/api";

const fmtDate = (v) => {
  try {
    return new Date(v).toLocaleDateString(undefined, { year: "numeric", month: "long", day: "numeric" });
  } catch {
    return "";
  }
};

export default function FeaturedStory() {
  const [post, setPost] = useState(null);

  useEffect(() => {
    api
      .get("/news?limit=1")
      .then((r) => {
        if (r.data && r.data.length > 0) setPost(r.data[0]);
      })
      .catch(() => {});
  }, []);

  if (!post) return null;

  return (
    <section className="py-16 bg-paper" data-testid="featured-story">
      <div className="max-w-[1140px] mx-auto px-6">
        <div className="mb-8 flex flex-wrap items-end justify-between gap-3">
          <div>
            <span className="inline-flex items-center gap-2.5 text-[13px] font-bold uppercase tracking-[0.14em] text-clay">
              <span className="w-6 h-[3px] rounded-sm bg-mango" />
              Featured story
            </span>
            <h2 className="mt-3 text-[clamp(28px,3.4vw,40px)]">Latest from HOFAVIPROC.</h2>
          </div>
          <Link to="/news" className="text-palm font-bold text-sm no-underline hover:underline" data-testid="featured-story-all-link">
            All stories →
          </Link>
        </div>

        <Link
          to={`/news/${post.slug}`}
          data-testid={`featured-story-card-${post.slug}`}
          className="group grid grid-cols-1 md:grid-cols-2 rounded-[16px] overflow-hidden bg-white border border-ink/10 no-underline text-ink hover:shadow-2xl transition"
        >
          <div className="aspect-[16/10] md:aspect-auto overflow-hidden bg-ink/5 relative">
            {post.cover_url ? (
              <img
                src={post.cover_url}
                alt=""
                loading="lazy"
                className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700"
              />
            ) : (
              <div
                className="w-full h-full flex items-end p-8"
                style={{ background: "linear-gradient(160deg, #123B23, #1F5C38)" }}
              >
                <span className="font-display text-white/95 text-4xl">HOFAVIPROC</span>
              </div>
            )}
            <div className="absolute top-4 left-4">
              <span className="bg-mango text-palm-deep px-3 py-1 rounded-full text-[11.5px] font-bold uppercase tracking-[0.1em]">
                {post.tag || "Story"}
              </span>
            </div>
          </div>
          <div className="p-8 md:p-10 flex flex-col justify-center gap-4">
            <div className="text-xs uppercase tracking-[0.14em] text-ink/55 font-bold">
              {fmtDate(post.created_at)}
            </div>
            <h3 className="font-display text-[clamp(24px,3vw,36px)] leading-[1.1]">{post.title}</h3>
            <p className="text-ink/75 text-[16.5px] leading-relaxed">{post.excerpt}</p>
            <span className="text-palm font-bold text-sm mt-2 inline-flex items-center gap-1">
              Read the full story <span aria-hidden="true">→</span>
            </span>
          </div>
        </Link>
      </div>
    </section>
  );
}
